import { useTranslation } from 'react-i18next'
import { useColumnLayout } from './useColumnLayout'

/**
 * Раскладка колонок реестра в форме оси `layout` у `DataTable`: порядок и набор из хранилища
 * под ключом таблицы плюс общие подписи — кнопка «Колонки», подсказка переноса, пункты меню.
 * Подписи одни на все реестры, поэтому живут здесь, а не повторяются на каждом экране.
 */
export function useTableLayout(tableKey: string, defaultHidden: readonly string[] = NO_HIDDEN) {
  const { t } = useTranslation()
  const layout = useColumnLayout(tableKey, defaultHidden)
  return {
    ...layout,
    labels: {
      menu: t('table.columns'),
      reorderHint: t('table.reorderHint'),
      showAll: t('table.columnsShowAll'),
      reset: t('table.columnsDefault'),
    },
  }
}

const NO_HIDDEN: readonly string[] = []
